import { ButtonType, LargeButton } from '@checkmarx/cx-ui';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import ValidationTopErrorMessage from '../../portal/controls/validationTopErrorMessage';
import PortalTextBox from '../../portal/portalTextBox';
import PortalCheckBox from '../../portal/controls/checkbox';

@inject('translationsStore', 'authStore', 'authenticationProvidersStore') @observer
export default class recoveryCodeForm extends Component {

    componentWillUnmount() {
        this.props.authStore.resetRecoveryForm();
    }

    handleCodeChange = e => this.props.authStore.setRecoveryCode(e.target.value);

    handleSubmitForm = (e) => {
        e.preventDefault();
        const isValid = this.props.authStore.validateRecoveryCodeLoginForm();

        if (isValid === false) {
            return;
        }
        this.props.authStore.setInProgress(true);
        this.props.authStore.setIsRecovery(true);
        this.props.authStore.isRecoveryCodeError = false;
        this.props.authStore.recoveryCodeErrorMessage = '';

        this.props.authStore.login().then((response) => {
            window.location.href = this.props.returnUrl;
            this.props.authStore.setInProgress(false);
        });
    };

    render() {
        const { values, recoveryCodeErrorMessage, inProgress  } = this.props.authStore;

        return (
            <div className="account-form">
                <form onSubmit={this.handleSubmitForm}>
                    <div>
                        <div style={{ fontSize: 'larger' }}>{this.props.translationsStore.translate('RECOVERY_CODE_VERIFICATION')}</div>
                        <div style={{ paddingTop: '50px', fontSize: '14px' }}>
                            {this.props.translationsStore.translate('RECOVERY_CODE_LOGIN_MESSAGE')}
                        </div>

                        <PortalTextBox
                            id='txtCode'
                            dataCy='code'
                            floatingLabelText={this.props.translationsStore.translate('RECOVERY_CODE')}
                            onChange={this.handleCodeChange}
                            autoComplete='off'
                            width='325px'
                            errorText={this.props.authStore.recoveryCodeErrorMessage}
                        />
                        <LargeButton
                            type='submit'
                            id='btnVerifyCode'
                            dataCy='login-button'
                            inProgress={inProgress}
                            text={this.props.translationsStore.translate('VERIFY')}
                            style={{ marginTop: '25px', width: '150px' }}
                        />
                        <LargeButton
                            text={this.props.translationsStore.translate('BACK')}
                            onClick={() => this.props.authStore.setLoginStep(this.props.authStore.loginSteps.twoFAForm)}
                            style={{ marginTop: '25px', marginLeft: '10px', width: '150px' }}
                        />
                    </div>
                </form>
            </div>);

    }
}


// WEBPACK FOOTER //
// ./src/components/account/recoveryCodeForm/index.jsx